import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Button,
  VStack,
  Text,
  Box,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
} from '@chakra-ui/react';

interface WalletConflictModalProps {
  isOpen: boolean;
  onClose: () => void;
  targetChain: 'bnb' | 'solana';
}

export const WalletConflictModal: React.FC<WalletConflictModalProps> = ({
  isOpen,
  onClose,
  targetChain,
}) => {
  const isBNB = targetChain === 'bnb';
  const isSolana = targetChain === 'solana';

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {isBNB ? 'Xung đột ví - Cần MetaMask' : 'Xung đột ví - Cần Phantom'}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <VStack spacing={4} align="stretch">
            <Alert status="warning">
              <AlertIcon />
              <Box>
                <AlertTitle>Phát hiện xung đột ví!</AlertTitle>
                <AlertDescription>
                  {isBNB
                    ? 'Phantom wallet đang can thiệp vào kết nối BNB. Để sử dụng BNB chain, bạn cần MetaMask.'
                    : 'MetaMask đang can thiệp vào kết nối Solana. Để sử dụng Solana chain, bạn cần Phantom wallet.'}
                </AlertDescription>
              </Box>
            </Alert>

            <Box>
              <Text fontWeight="bold" mb={2}>
                {isBNB ? 'Để kết nối BNB chain:' : 'Để kết nối Solana chain:'}
              </Text>
              <VStack spacing={2} align="stretch">
                {isBNB ? (
                  <>
                    <Text>1. Tắt Phantom wallet extension tạm thời</Text>
                    <Text>
                      2. Hoặc sử dụng trình duyệt riêng chỉ có MetaMask
                    </Text>
                    <Text>3. Hoặc sử dụng chế độ ẩn danh với MetaMask</Text>
                  </>
                ) : (
                  <>
                    <Text>1. Tắt MetaMask extension tạm thời</Text>
                    <Text>
                      2. Hoặc sử dụng trình duyệt riêng chỉ có Phantom
                    </Text>
                    <Text>3. Hoặc sử dụng chế độ ẩn danh với Phantom</Text>
                  </>
                )}
              </VStack>
            </Box>

            <Box>
              <Text fontWeight="bold" mb={2}>
                Hướng dẫn chi tiết:
              </Text>
              <VStack spacing={2} align="stretch">
                <Text fontSize="sm">
                  • <strong>Tắt extension:</strong> Click vào icon extension và
                  tắt tạm thời
                </Text>
                <Text fontSize="sm">
                  • <strong>Chế độ ẩn danh:</strong> Mở tab ẩn danh và chỉ cài
                  extension cần thiết
                </Text>
                <Text fontSize="sm">
                  • <strong>Trình duyệt riêng:</strong> Sử dụng Chrome cho
                  MetaMask, Firefox cho Phantom
                </Text>
              </VStack>
            </Box>

            <Button colorScheme="blue" onClick={onClose}>
              Tôi hiểu rồi
            </Button>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
